export default __webpack_public_path__ + "static/media/1903.bad4fef7.png";